import React, { FC } from "react";
import { Image } from "semantic-ui-react";

interface Props {
  path: string;
}

const SariaImage: FC<Props> = ({ path = "" }) => (
  <>
    <Image src={path} />
  </>
);

export default SariaImage;
